import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import Result from './result'

const SearchResults = ({ query, hits, totalResults, totalPages, activePage, setActivePage, themeColor, setShowSearchModal }) => (
  <SearchResultContainer>
    {!query || query.length === 0 ? (
      <ResultsEmpty>
        <div>No results found for query</div>
        <div>"{query}"</div>
      </ResultsEmpty>
    ) : hits && typeof hits === 'object' && hits.length >= 1 ? (
      hits.map(hit => <Result key={hit.id || hit.source.id} hit={hit} setShowSearchModal={setShowSearchModal} />)
    ) : (
      <ResultsEmpty>
        <div>No results found for query</div>
        <div>"{query}"</div>
      </ResultsEmpty>
    )}
  </SearchResultContainer>
)

export default SearchResults

const SearchResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  mark,
  .mark {
    background-color: ${props => props.theme.mark};
  }
  .result:last-child {
    border-bottom: 0px !important;
  }
`

const ResultsEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15.5px;
  height: 100%;
  width: 100%;
  color: ${props => props.theme.textGreyTinted};
  padding: 0px 20px;
  text-align: center;
  line-height: 1.7;
  text-align: center;
  flex-direction: column;
  word-break: break-all;
  padding: 0px 20px;
`
